import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const creditEffect: SxStyle = {
  '.credit-value': {
    color: (p) => p.palette.success[600],
  },
};

export const divider: SxStyle = {
  my: (p) => p.spacing(0.5),
};

export const content: SxStyle = {
  padding: (p) => p.spacing(1),
  background: (p) => p.palette.grey[200],
  borderRadius: (p) => p.spacing(0.5),
};
